module.exports = "/assets/8f27f10426f9f0ff0a7801faa3d7f9c4.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos-small/VH.png
// module id = 3045
// module chunks = 0